import React, { Component } from "react";
import _ from "lodash";
import { Pagination } from "antd";
import { Select } from "antd";
import { withRedux } from "../hoc";
import { LayoutPage, ArticleItem, Button, FilterList } from "../components";
import { showPromotions } from "../selectors/promotion";

const Option = Select.Option;

const pageSize = 6;

const mapStateToProps = ({ language, t, promotion, promotionCategories, promotionPage }) => {
  return {
    language,
    t,
    promotions: _.get(promotion, "data"),
    promotionCategories: _.get(promotionCategories, "data"),
    promotionPage: _.get(promotionPage, "data")
  };
};

@withRedux(mapStateToProps)
export default class Promotion extends Component {
  state = {
    currentPage: 1
  };
  onChangePage = page => {
    this.setState({
      currentPage: page
    });
  };

  getDropdownMenu = ({ onChangeFilter, filterValue, promotionTypes }) => {
    const { t } = this.props;
    const menu = (
      <Select labelInValue defaultValue={{ key: filterValue }} style={{ width: 150 }}>
        {_.map(promotionTypes, (item, key) => {
          return (
            <Option
              key={key}
              value={_.get(item, "id")}
              onClick={() => onChangeFilter("category_id", _.get(item, "id"))}
            >
              {t(_.get(item, "name"))}
            </Option>
          );
        })}
      </Select>
    );

    return menu;
  };
  handleFilterPromotion = (onChangeFilter, item) => {
    onChangeFilter("category_id", _.get(item, "id"));
    this.setState({
      currentPage: 1
    });
  };
  render() {
    const { promotions, t, promotionCategories, promotionPage } = this.props;
    const { currentPage } = this.state;

    const video = _.get(promotionPage, "video");
    const imageBanner = _.get(promotionPage, "imageBanner");
    const imageBannerMobile = _.get(promotionPage, "imageBannerMobile");

    const types = _.map(promotionCategories, category => {
      return { id: _.get(category, "id"), name: _.get(category, "name") };
    });
    const promotionTypes = [{ id: null, name: "All" }, ...types];

    const showItems = showPromotions(promotions);

    return (
      <div className="promotion-page">
        <LayoutPage
          pageName="PROMOTIONS"
          media={video}
          image={imageBanner}
          imageMobile={imageBannerMobile}
        />
        <div className="container">
          <FilterList
            dataSource={showItems}
            renderHeader={({ onChangeFilter, filterValue }) => {
              return (
                <div className="menu-bar">
                  <div className="menu-bar-desktop">
                    {_.map(promotionTypes, (item, key) => {
                      return (
                        <Button
                          key={key}
                          className={`button-menu ${
                            filterValue === _.get(item, "id") ? "active-button" : "button-menu-bar"
                          }`}
                          onClick={() => this.handleFilterPromotion(onChangeFilter, item)}
                          // onClick={() => onChangeFilter('category_id', _.get(item, 'id'))}
                          style={{ zIndex: 1 }}
                        >
                          {t(_.get(item, "name"))}
                        </Button>
                      );
                    })}
                  </div>
                  <div className="dropdown-menu">
                    {this.getDropdownMenu({ onChangeFilter, filterValue, promotionTypes })}
                  </div>
                </div>
              );
            }}
            renderList={items => {
              const showItem = _.slice(items, (currentPage - 1) * pageSize, currentPage * pageSize);
              return (
                <div>
                  <div className="container-all-article">
                    <div className="row">
                      {_.map(showItem, (item, key) => {
                        return (
                          <div className="col-md-4" key={key}>
                            <div className="promotion-item">
                              <ArticleItem
                                data={item}
                                pathOnClick={`/promotion/detail/${item.id}`}
                                darkFont
                                showDate
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="container-pagination">
                    <Pagination
                      current={currentPage}
                      defaultPageSize={pageSize}
                      total={_.size(items)}
                      onChange={this.onChangePage}
                    />
                  </div>
                </div>
              );
            }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Promotion.js